import React from 'react';
import PropTypes from 'prop-types';
import validator from 'validator';
import ImageButton from 'ImageButton';

const RecipientsList = props => (
  <React.Fragment>
    <ol>
      {
      props.emails.map((email, i) => (
        <li key={i}>
          <input
            type="text"
            onBlur={() => props.handleBlur(i)}
            className={(!validator.isEmail(email.trim()) && props.hasEmailInputBlurred[i]) ? 'error-outline' : ''}
            placeholder="Email"
            value={email}
            onChange={event => props.handleEmailChange(i, event)}
          />
          <ImageButton
            className="self-serve-builder-delete-button"
            src="/images/self-serve-builder/side-panel/x-delete-icon-2x.png"
            srcHover="/images/self-serve-builder/side-panel/x-delete-icon-hover-2x.png"
            onClick={() => props.removeEmailField(i)}
            alt="Remove Email"
            disabled={props.emails.length === 1}
            style={{ cursor: props.emails.length === 1 ? 'no-drop' : 'pointer' }}
          />
          {(!validator.isEmail(email.trim()) && props.hasEmailInputBlurred[i]) ?
            (
              <p className="add-recipients-error">
                {email} is not a valid email address.
              </p>
            ) : null
          }
        </li>
      ))
      }
    </ol>
  </React.Fragment>
);

RecipientsList.propTypes = {
  emails: PropTypes.arrayOf(
    PropTypes.string,
  ).isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleEmailChange: PropTypes.func.isRequired,
  hasEmailInputBlurred: PropTypes.arrayOf(
    PropTypes.bool,
  ).isRequired,
  removeEmailField: PropTypes.func.isRequired,
};

export default RecipientsList;



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/RecipientManager/RecipientsList.jsx